<template>
    <!--<div>-->
        <!--<SiteHeader></SiteHeader>-->
        <component v-if="component" :is="component"></component>
        <!--<SiteFooter></SiteFooter>-->
    <!--</div>-->
</template>
<script>


import {get} from "vuex-pathify";
// import SiteHeader from "./../_commons/SiteHeader";
// import SiteFooter from "./../_commons/SiteFooter";

export default {
    components:{
        // SiteHeader,
        // SiteFooter
    },
    computed: {
        currentStepName() {
            return this.$route.params.step
        },
        form: get('form/form'),
        step: get('form/form@_steps.:currentStepName'),
        component() {
            return _.get(this.step,'_parent_component') || this.form._component
        }
    },
    async beforeCreate() {
        await this.$store.dispatch('form/guardRoute')
    },
};

</script>

